module.exports = __webpack_public_path__ + "static/media/my_class.029a37c7.png";